import sl from "../../../../components/startups-landing/startups-landing-sections.module.css"
import textStyles from "../../../../shared/styles/section-text.module.css"
import styles from "./meet-kate.module.css"

const DIFFERENTIATORS = [
	{
		title: "She starts with you, not the job listing",
		body: "Every other platform starts with a database of jobs and asks you to search it. Kate starts with your profile, your goals, and your non-negotiables, then works outward from there. The search is built around you, not the other way around.",
	},
	{
		title: "She learns, she doesn't just filter",
		body: 'A keyword search returns the same results every time. Kate gets better the more you talk. She understands nuance that no filter captures: "I want a startup but not pre-revenue" or "remote is fine but occasional travel works too." Tell her once and she remembers.',
	},
	{
		title: "She acts on your behalf",
		body: "Most platforms show you a list and leave you to it. Kate goes further. She can ask the hiring team questions, get answers, and arrange introductions when you're ready. You stay in control of every decision, but Kate does the legwork.",
	},
	{
		title: "She qualifies the opportunity before you commit",
		body: "You never have to send a cold application and wait. Before you decide to move forward, Kate can get details from the hiring team about culture, expectations, and the real shape of the role. You walk into every conversation fully informed.",
	},
	{
		title: "One conversation replaces dozens of applications",
		body: "The traditional job hunt is a numbers game. Apply to 50 roles, hear back from 5, interview with 2. Kate flips that entirely. Fewer interactions, better fit, and higher signal on both sides.",
	},
]

const MeetKate = () => {
	return (
		<section id="meet-kate" className={styles.section}>
			<div className={`container ${sl.sectionContainer}`}>
				<header className={styles.sectionHeader}>
					<div className={sl.labelCenter}>Meet Kate</div>
					<h2 className={styles.title}>
						<span className={styles.titleLine}>The only career ally you'll ever need.</span>
					</h2>
				</header>

				<p className={`${sl.bodyLg} ${textStyles.centeredDescription} ${styles.lead}`}>
					Kate is your career ally. Tell her what matters, what doesn't, and what you'd never compromise on. She searches until the right roles find you. Think of her as the recruiter who actually works for you, not the company.
				</p>

				<div className={styles.contentNarrow}>
					<h3 className={styles.diffSubheader}>Why Kate is different</h3>
					<div className={styles.diffList}>
						{DIFFERENTIATORS.map((item) => (
							<article className={styles.diffRow} key={item.title}>
								<h3 className={styles.diffTitle}>{item.title}</h3>
								<p className={styles.diffBody}>{item.body}</p>
							</article>
						))}
					</div>
				</div>
			</div>
		</section>
	)
}

export default MeetKate
